module.exports = __webpack_public_path__ + "media/containers/InvestmentCalculationPDF/Images/Footer-dbb013b5d11ce683c0fd13cf1cbab43c.png";